import { UploadOutlined } from "@ant-design/icons";
import { Upload } from "antd";
import i18n from "i18next";
import type { FC } from "react";

import { SecondaryButton } from "../Buttons/components/ActionButton";
import type { AntCustomFormField } from "../Form/types/types";

export interface CsvImportModalButtonProps extends AntCustomFormField<undefined> {
    readOnly?: boolean;
    callback?: (content: string) => void;
}

/**
 * CSV import component for uploading content.
 * Parses CSV file and return.
 */
export const CsvImportModalButton: FC<CsvImportModalButtonProps> = ({ readOnly, callback }) => {
    const beforeUpload = async (file: File) => {
        try {
            const content = await file.text();

            if (callback) {
                callback(content);
            }
        } catch (error) {
            /* empty */
        }

        return false;
    };

    return (
        <Upload accept=".csv,text/csv" beforeUpload={beforeUpload} disabled={readOnly}>
            <SecondaryButton name="csv_import_modal_button" icon={<UploadOutlined />} disabled={readOnly}>
                {i18n.t("csvImport.modal.title", { type: "CSV" })}
            </SecondaryButton>
        </Upload>
    );
};
